/** แปลง API error code เป็นข้อความ UI (ภาษาลาว) */
const CF_API_ERROR_MESSAGES: Record<string, string> = {
  ALLOCATION_BELOW_SOLD: "ໂຄວຕ້າຕ້ອງບໍ່ຕ່ຳກວ່າຈຳນວນທີ່ຮັບ CF ແລ້ວ",
  QUANTITY_EXCEEDS_AVAILABLE_STOCK: "ໂຄວຕ້າທີ່ເຫຼືອເກີນສະຕັອກຄັງທີ່ຂາຍໄດ້",
  QUANTITY_EXCEEDS_STOCK: "ບໍ່ມີສະຕັອກຄັງທີ່ຂາຍໄດ້",
  CF_CODE_NOT_FOUND:
    "ບໍ່ພົບລະຫັດ CF ໃນໂພສນີ້ — ກວດວ່າເປີດຂາຍ ແລະ ພິມລະຫັດຖືກຕ້ອງ (ບໍ່ໃສ່ຊ່ອງກາງ code)",
  SESSION_QUOTA_EXCEEDED: "ໂຄວຕ້າໂພສເຕັມແລ້ວ — ຫຼຸດຈຳນວນ ຫຼື ເພີ່ມ quota ສິນຄ້າ",
  OUT_OF_STOCK_ADMIN: "ສິນຄ້າໃນຄັງບໍ່ພໍ — stock ກາງບໍ່ພໍສຳລັບຈຳນວນທີ່ຂໍ",
  INSUFFICIENT_CF_ALLOCATED: "ສິນຄ້າໃນຄັງບໍ່ພໍ — stock ກາງບໍ່ພໍສຳລັບຈຳນວນທີ່ຂໍ",
  COMMENT_NOT_FOUND: "ບໍ່ພົບຄອມເມັນນີ້ ຫຼື ບໍ່ແມ່ນຂອງໂພສນີ້",
  MESSENGER_PROFILE_NOT_FOUND: "ບໍ່ພົບລູກຄ້າ Messenger ນີ້ໃນ Facebook Page ຂອງໂພສ",
  COMMENT_ORDER_REQUIRED: "ຄອມເມັນນີ້ຍັງບໍ່ມີອໍເດີ້ ຈຶ່ງຍັງເຊື່ອມ Messenger ບໍ່ໄດ້",
  COMMENT_MESSENGER_PROFILE_CONFLICT:
    "ຄອມເມັນ ຫຼື ອໍເດີ້ນີ້ຖືກເຊື່ອມກັບລູກຄ້າ Messenger ຄົນອື່ນແລ້ວ",
  COMMENT_ALREADY_HAS_ORDER: "ຄອມເມັນນີ້ມີອໍເດີ້ແລ້ວ",
  DUPLICATE_ORDER: "ລູກຄ້າຄົນນີ້ສັ່ງສິນຄ້ານີ້ໃນໂພສແລ້ວ",
  DUPLICATE_ORDER_LOCKED: "ອໍເດີ້ເດີມຖືກຢືນຢັນ/ກຳລັງດຳເນີນການແລ້ວ — ບໍ່ສາມາດເພີ່ມຈຳນວນໄດ້",
  INVALID_QUANTITY: "ຈຳນວນບໍ່ຖືກຕ້ອງ — ຕ້ອງເປັນຕົວເລກ ≥ 1",
  INVALID_QUANTITY_ADJUSTMENT: "ຈຳນວນໃໝ່ຕ້ອງນ້ອຍກວ່າຈຳນວນເກົ່າ ແລະ ບໍ່ຕ່ຳກວ່າ 0",
  ORDER_QUANTITY_LOCKED: "ອໍເດີນີ້ຈ່າຍເງິນ ຫຼື ຖືກຢືນຢັນແລ້ວ — ບໍ່ສາມາດປັບຈຳນວນໄດ້",
  ORDER_QUANTITY_AUTHORITY_CONFLICT: "ຂໍ້ມູນອໍເດີ ແລະ stock ບໍ່ກົງກັນ — ບໍ່ໄດ້ປ່ຽນຂໍ້ມູນ",
  ADMIN_ORDER_MESSENGER_PAGE_NOT_FOUND:
    "ບໍ່ພົບການເຊື່ອມ Facebook Page ຂອງ session ນີ້ — ກວດ session ແລະເຊື່ອມ Page ໃໝ່",
  ADMIN_ORDER_MESSENGER_OWNER_CONFLICT:
    "ອໍເດີ້ນີ້ຖືກຜູກກັບ Page/ລູກຄ້າ/session ອື່ນ — ບໍ່ໄດ້ປ່ຽນ owner ເພື່ອປ້ອງກັນສົ່ງຂໍ້ຄວາມຜິດຄົນ",
  IDEMPOTENCY_KEY_CONFLICT: "ຄຳຂໍນີ້ເຄີຍຖືກໃຊ້ກັບຈຳນວນອື່ນ — ກະລຸນາໂຫຼດໜ້າໃໝ່",
  ORDER_QUANTITY_PROJECTION_WRITE_FAILED:
    "Admin ປັບ stock ແລ້ວ ແຕ່ຂໍ້ມູນ CF ຍັງອັບເດດບໍ່ຄົບ — ກົດລອງໃໝ່ດ້ວຍຄຳຂໍເດີມ",
  INVALID_PRICE: "ສິນຄ້ານີ້ຍັງບໍ່ມີລາຄາ — ກະລຸນາຕັ້ງລາຄາໃນ Admin ກ່ອນ",
  INVALID_DISCOUNT_PERCENT: "ສ່ວນຫຼຸດ % ບໍ່ຖືກຕ້ອງ (0–100)",
  INVALID_LIST_DISCOUNT_FIXED: "ສ່ວນຫຼຸດລາຍການ (LAK) ບໍ່ຖືກຕ້ອງ",
  INVALID_PRODUCT_DISCOUNT_FIXED: "ສ່ວນຫຼຸດສິນຄ້າ (LAK) ບໍ່ຖືກຕ້ອງ",
  INVALID_PRINT_FEE_CODE: "ລະຫັດຄ່າພິມບໍ່ຖືກຕ້ອງ",
  PREORDER_NOT_ACTIVE: "ສິນຄ້ານີ້ບໍ່ເປີດຮັບ preorder ໃນຊ່ວງນີ້ — ກວດການຕັ້ງຄ່າໃນ Admin",
  ORDER_CREATE_FAILED: "ບໍ່ສາມາດສ້າງອໍເດີ້ໄດ້ — ລອງໃໝ່ອີກຄັ້ງ",
  FEED_NOT_FOUND: "ບໍ່ພົບໂພສ",
  SESSION_NOT_FOUND: "ບໍ່ພົບ session ຂອງໂພສ",
  PAGE_TOKEN_EXPIRED: "Token Facebook ໝົດອາຍຸ — ກະລຸນາເຊື່ອມ Page ໃໝ່",
  FACEBOOK_PERMISSIONS_REQUIRED:
    "ສິດ Facebook Page ບໍ່ຄົບ — ກະລຸນາເຊື່ອມຕໍ່ Facebook ໃໝ່",
  FACEBOOK_RATE_LIMITED: "Facebook ຈຳກັດຈຳນວນຄຳຂໍຊົ່ວຄາວ — ກະລຸນາລໍຖ້າແລ້ວລອງໃໝ່",
  LIVE_PERMISSION_DENIED: "Page ນີ້ບໍ່ມີສິດສ້າງ Live — ກວດສິດ Facebook ແລະເຊື່ອມ Page ໃໝ່",
  LIVE_GRAPH_CREATE_FAILED:
    "Facebook ບໍ່ສາມາດສ້າງ Live ໄດ້ໃນຕອນນີ້ — ຮ່າງ Live ຍັງຖືກເກັບໄວ້",
  LIVE_CREATE_IN_PROGRESS: "ກຳລັງສ້າງ Live ຈາກຄຳຂໍເດີມ — ລໍຖ້າຄາວໜຶ່ງແລ້ວລອງອີກຄັ້ງ",
  INVALID_LIVE_REFERENCE: "Facebook Live URL ຫຼື Video ID ບໍ່ຖືກຕ້ອງ",
  LIVE_PAGE_MISMATCH: "Facebook Live ນີ້ບໍ່ແມ່ນຂອງ Page ທີ່ເລືອກ",
  LIVE_LOOKUP_FAILED: "ກວດສອບ Facebook Live ບໍ່ສຳເລັດ — ລອງໃໝ່ ຫຼື ເຊື່ອມ Page ໃໝ່",
  INVALID_IDEMPOTENCY_KEY: "ລະຫັດກັນການສ້າງຊ້ຳບໍ່ຖືກຕ້ອງ — ລອງໃໝ່",
  LIVE_CREATED_DB_INCOMPLETE:
    "Facebook ສ້າງ Live ແລ້ວ ແຕ່ບັນທຶກໃນລະບົບບໍ່ຄົບ — ກົດອັບເດດລາຍການ",
  DRAFT_CREATE_FAILED: "ສ້າງຮ່າງ Live ບໍ່ສຳເລັດ — ລອງໃໝ່ອີກຄັ້ງ",
  DRAFT_NOT_FOUND: "ບໍ່ພົບຮ່າງ Live ນີ້",
  DRAFT_ALREADY_CREATED: "ຮ່າງ Live ນີ້ຖືກສ້າງໄປແລ້ວ",
  TITLE_REQUIRED: "ກະລຸນາໃສ່ຊື່ Live",
  PRODUCTS_REQUIRED: "ກະລຸນາເພີ່ມສິນຄ້າກ່ອນສ້າງ Live",
  WAREHOUSE_REQUIRED: "ກະລຸນາເລືອກຄັງສິນຄ້າກ່ອນສ້າງ Live",
  GRAPH_LIVE_CREATE_NO_ID: "Facebook ບໍ່ສົ່ງລະຫັດ Live ກັບຄືນມາ — ລອງໃໝ່",
  FEED_UPSERT_FAILED: "ບັນທຶກ Live ໃນລະບົບບໍ່ສຳເລັດ",
  SESSION_CREATE_FAILED: "ສ້າງ session ສຳລັບ Live ບໍ່ສຳເລັດ",
  ADMIN_DB_WRITE_FAILED: "ເຊື່ອມ Admin DB ບໍ່ໄດ້ — ລອງໃໝ່ພາຍຫຼັງ",
  ADMIN_DB_LOCK_TIMEOUT: "ສະຕັອກກຳລັງຖືກອັບເດດ — ລະບົບຈະລອງໃໝ່ອັດຕະໂນມັດ",
  REQUEST_FAILED: "ຄໍາຮ້ອງຂໍລົ້ມເຫຼວ — ລອງໃໝ່ອີກຄັ້ງ",
  SERVER_ERROR: "ເຊີບເວີມີບັນຫາ — ລອງໃໝ່ພາຍຫຼັງ",
  UNKNOWN: "ເກີດຂໍ້ຜິດພາດ — ລອງໃໝ່ອີກຄັ້ງ",
};

export type CfApiErrorPayload = {
  code?: string;
  message?: string;
  error?: string;
};

export function formatManualOrderErrorMessage(codeOrMessage: string): string {
  const key = codeOrMessage.trim();
  if (CF_API_ERROR_MESSAGES[key]) {
    return CF_API_ERROR_MESSAGES[key];
  }
  for (const [code, message] of Object.entries(CF_API_ERROR_MESSAGES)) {
    if (key.includes(code)) return message;
  }
  if (key && key !== "UNKNOWN" && !key.includes(" ")) {
    return `ເກີດຂໍ້ຜິດພາດ (${key})`;
  }
  return CF_API_ERROR_MESSAGES.UNKNOWN ?? "ເກີດຂໍ້ຜິດພາດ";
}

export function formatCfApiErrorMessage(codeOrMessage: string): string {
  return formatManualOrderErrorMessage(codeOrMessage);
}

export function parseCfApiErrorPayload(
  payload: CfApiErrorPayload | null | undefined,
  status: number,
): { code: string; reason: string } {
  const rawCode = payload?.code?.trim();
  const rawError =
    typeof payload?.error === "string" ? payload.error.trim() : "";
  const rawMessage =
    typeof payload?.message === "string" ? payload.message.trim() : "";

  const code =
    rawCode ??
    (/^[A-Z][A-Z0-9_]*$/.test(rawError) ? rawError : null) ??
    (status >= 500 ? "SERVER_ERROR" : "REQUEST_FAILED");

  const reason = rawMessage || formatManualOrderErrorMessage(code);
  return { code, reason };
}

export function getManualOrderErrorReason(err: unknown): string {
  if (err instanceof Error && err.message.trim()) {
    const msg = err.message.trim();
    if (msg.startsWith("DUPLICATE_ORDER:")) {
      const shopCode = msg.slice("DUPLICATE_ORDER:".length).trim();
      return shopCode
        ? `ລູກຄ້າມີອໍເດີ້ ${shopCode} ຢູ່ແລ້ວ — ບໍ່ສາມາດສ້າງຊ້ຳ`
        : (CF_API_ERROR_MESSAGES.DUPLICATE_ORDER ?? "ອໍເດີ້ນີ້ມີຢູ່ແລ້ວ");
    }
    if (
      msg.includes("ບໍ່") ||
      msg.includes("ໂຄວ") ||
      msg.includes("ສິນຄ້າ") ||
      msg.includes("cf_allocated") ||
      msg.includes("ເກີດ") ||
      msg.includes("ອໍເດີ້")
    ) {
      return msg;
    }
    return formatManualOrderErrorMessage(msg);
  }
  if (
    typeof err === "object" &&
    err !== null &&
    "code" in err &&
    typeof (err as { code: unknown }).code === "string"
  ) {
    return formatManualOrderErrorMessage((err as { code: string }).code);
  }
  return CF_API_ERROR_MESSAGES.UNKNOWN ?? "ເກີດຂໍ້ຜິດພາດ";
}

export function cfApiErrorBody(code: string, errorLabel: string) {
  return {
    code,
    message: formatManualOrderErrorMessage(code) || errorLabel,
  };
}
